export default {
    fonts: {
        /**
         * @property {string} display for headings and such
         */
        display: `"Open Sans", "SF UI Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,

        /**
         * @property {string} ui (default) for text and UI components
         */
        ui: `"Open Sans", "SF UI Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,

        /**
         * @property {string} mono when monospace is bae
         */
        mono: `"SF Mono", "Monaco", "Inconsolata", "Fira Mono", "Droid Sans Mono", "Source Code Pro", monospace`
    }
};
